import classNames from 'classnames'
import { FastlyImage } from '@components/common/image'

type InstitutionsProps = {
  children?: React.ReactNode
  className?: any
}

type InstitutionType = {
  name: string
  image: {
    label: string
    alt: string
  }
}
const IMAGE_PATH = '/images/home/competitions-fold'
const institutions: InstitutionType[] = [
  {
    name: 'IIT, Bombay',
    image: {
      label: 'iit-bombay',
      alt: 'IIT Bombay',
    },
  },
  {
    name: 'IIT, Guwahati',
    image: {
      label: 'iit-ghy',
      alt: 'IIT Guwahati',
    },
  },
  {
    name: 'IIT, Roorkee',
    image: {
      label: 'iit-roorkee',
      alt: 'IIT Roorkee',
    },
  },
  {
    name: 'BITS, Pilani',
    image: {
      label: 'bits-pilani',
      alt: 'BITS Pilani',
    },
  },
  {
    name: 'Hewlett Packard',
    image: {
      label: 'hewlett-packard',
      alt: 'Hewlett Packard',
    },
  },
  {
    name: 'Times of India',
    image: {
      label: 'times-of-india',
      alt: 'Times of India',
    },
  },
]

const Institutions = ({ className }: InstitutionsProps) => {
  return (
    <div
      className={classNames(
        'grid grid-cols-2 gap-y-16 lg:gap-y-0 lg:grid-cols-6  w-full justify-between',
        className
      )}
    >
      {institutions.map((institution) => (
        <div
          key={institution.image.label}
          className="flex flex-col text-center"
        >
          <div>
            <FastlyImage
              alt={institution.image.alt}
              src={`${IMAGE_PATH}/${institution.image.label}.webp`}
              width={96}
              height={96}
            />
          </div>
          <span>{institution.name}</span>
        </div>
      ))}
    </div>
  )
}

export default Institutions
